module.exports = __webpack_public_path__ + "img/jobs-mobile@2x.535d655.png";